export enum ContractType {
  VEHICLE_ONLY = "Vehicle Only",
  LABOR_ONLY = "WorkForce Only",
  VEHICLE_INCL_LABOR = "Vehicle + WorkForce",
}

// Contract  Type Enum
export enum Category {
  SELECT_CATEGORY = "Select Category",
  FIXED_BILLING = "Fixed Billing",
  FIXED = "Fixed (MGK)",
  PER_KM = "Per KM",
  PER_SEAT = "Per Seat",
  ROUTE_BASED = "Route Based",
}

// Contract  Status Enum
export enum ContractStatus {
  DRAFT = "Draft",
  ACTIVE = "Active",
  SUSPENDED = "Suspended",
  TERMINATED = "Terminated",
  EXPIRED = "Expired",
}

// Resource Type Enum
export enum ResourceType {
  DRIVER = "DRIVER",
  CLEANER = "CLEANER",
  LADY_ATTENDANT = "LADY_ATTENDANT",
  OTHER = "OTHER",
}

// Rate Type Enum
export enum RateType {
  DAILY = "Daily",
  MONTHLY = "Monthly",
  HOURLY = "Hourly",
  TRIP_BASIS = "Trip Basis",
}

// Billing Cycle Enum
export enum BillingCycle {
  DAILY = "Daily",
  WEEKLY = "Weekly",
  MONTHLY = "Monthly",
  QUARTERLY = "Quarterly",
  HALF_YEARLY = "Half Yearly",
  YEARLY = "Yearly",
  ONE_TIME = "One Time",
}

// Billing Type Enum
export enum BillingType {
  KM = "KM",
  TRIP = "Trip",
  DAYS = "Days",
  MONTHS = "Months",
  YEARS = "Years",
}

// Profit Calculation Method Enum
export enum ProfitCalculationMethod {
  MIN_GUARANTEE_PROFIT = "Min Guarantee Profit",
  REVENUE_BASED = "Revenue Based",
  NET_PROFIT = "Net Profit",
  GROSS_MARGIN = "Gross Margin",
}

// Calculation Method Enum
export enum CalculationMethod {
  PERCENTAGE = "Percentage",
  FIXED_AMOUNT = "Fixed Amount",
  TIERED = "Tiered",
  FORMULA = "Formula",
}

export enum AdditionalType {
  DRIVER_BHATTA = "Driver Bhatta",
  DAILY_PERMIT = "Daily Permit",
  LOADING = "Loading",
  UNLOADING = "Unloading",
  PARKING = "Parking",
  NIGHT_HALT = "Night Halt",
  CLEANER_BHATTA = "Cleaner Bhatta",
  UNION_CHARGES = "Union Charges",
  WEIGHT_CHARGES = "Weight Charges",
}

export enum VehicleCategory {
  AMBULANCE = "Ambulance",
  BUS = "Bus",
  CAR = "Car",
  TRUCK = "Truck",
  OTHER = "Other",
}

// vehicle model based on vehicle category dynamically
export const getVehicleModels = (vehicleCategory: VehicleCategory) => {
  switch (vehicleCategory) {
    case VehicleCategory.AMBULANCE:
      return ["ALSA", "BLSA", "BLSA-M", "BLSA-S", "MV", "MV-M"];
    default:
      return [];
  }
};

export const getVehicleMakes = (vehicleCategory: VehicleCategory) => {
  switch (vehicleCategory) {
    case VehicleCategory.AMBULANCE:
      return ["Force", "Maruti EECO", "Tata Winger", "Tatat Winger BS6 3200"];
    default:
      return [];
  }
};

export enum PricingType {
  FIXED = "Fixed",
}

export enum LimitType {
  DAILY = "Daily",
  WEEKLY = "Weekly",
  MONTHLY = "Monthly",
}
